import { UserRoleService } from "../../core/http/service/UserRoleService";
import { getCodigoByDescricao } from "../../enums/Roles";
import { cleanMask } from "../../helpers/HelperFunctions";
import BaseResponse from "../../models/core/BaseResponse";
import PersonCompany from "../../models/core/userRole/PersonCompany";
import Role from "../../models/core/userRole/Role";


export const RESET: string = 'RESET';
export const FETCH_ALL_ROLES: string = 'FETCH_ALL_ROLES';
export const FETCH_ALL_USERS_WITH_ROLES: string = 'FETCH_ALL_USERS_WITH_ROLES';
export const ASSIGN_ROLES_TO_USER: string = 'ASSIGN_ROLES_TO_USER';
export const FILTER_BY_NAME_CPF: string = 'FILTER_BY_NAME_CPF';
export const FILTER_BY_COMPANY_ROLE: string = 'FILTER_BY_COMPANY_ROLE';

const sendToAnalytics = (action: string = '', error: any = null) => {
    console.error(action, error);
}

export const fetchAllRoles = () => {
    const service: UserRoleService = new UserRoleService()

    return async (dispatch: any) => {
        try {

            const response: any = await service.getAllRoles()
            const rolesCombo: any[] = []
            response.data.data.forEach((data: any)=>{
                const role: Role = new Role().fromJSON({...data});
                if(role.codigo !== null ) rolesCombo.push({label: role.nome, value: role.codigo, atribuivel: role.atribuivel })
            })

            dispatch({
                type: FETCH_ALL_ROLES,
                roles: rolesCombo,
                rolesCombo: rolesCombo
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
};

const getUsersFromService = async (response: any)=>{
    const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
    const users: PersonCompany[] = []
    baseResponse.data.forEach((personCompany: any)=>{
        users.push(new PersonCompany().fromJSON({...personCompany}))
    })
    return users;
}

export const fetchAllUsersWithRoles = ()=>{
    const service: UserRoleService = new UserRoleService()

    return async (dispatch: any) => {
        try {
            const response: any = await service.getAllUsersWithRoles()
            const users = await getUsersFromService(response)

            dispatch({
                type: FETCH_ALL_USERS_WITH_ROLES,
                users: users
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const assignRolesToUser = (userId: string, roleList: string[])=>{
    const service: UserRoleService = new UserRoleService()

    return async (dispatch: any) => {
        try {
            const rolesToAssign: string[] = []
            roleList.forEach(role=>{
                rolesToAssign.push(getCodigoByDescricao(role))
            })

            const body = { id: userId, perfis: rolesToAssign }
            await service.assignRolesToUser(body)

        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const filterUserByNameOrCPF = (searchQuery: string)=>{
    const service: UserRoleService = new UserRoleService()

    return async (dispatch: any) => {
        try {
            const cleanQuery = searchQuery.replace(/[^a-zA-Z0-9( )*]+/g, '');
            const response: any = await service.getUsersByNameOrCpf(cleanQuery)
            const users = await getUsersFromService(response)

            dispatch({
                type: FILTER_BY_NAME_CPF,
                filteredUsers: users 
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const filterUsersByCompanyOrRole = (companies: string[], roles: string[])=>{
    const service: UserRoleService = new UserRoleService()

    return async (dispatch: any) => {
        try {
            const response: any = await service.getAllUsersWithRoles()
            const users = await getUsersFromService(response)
            const rolesCodes: string[] = []

            roles.forEach(role=>{
                rolesCodes.push(getCodigoByDescricao(role))
            })

            const companiesOrRoles = [...companies, ...rolesCodes];

            let filteredUsers: PersonCompany[] = []
            filteredUsers = users.filter(user=>{
                return (rolesCodes.length > 0 ? user.perfis?.some(elem=> rolesCodes.includes(elem)) : true)
                && (companies.length > 0 ? companies.includes(user.empresa?.nomeFantasia ?? '') : true)
            })

            dispatch({
                type: FILTER_BY_COMPANY_ROLE,
                filteredUsers: companiesOrRoles.length > 0? filteredUsers : users
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}
